import { Button } from "@components/ui/buttons/Button";
import { convertToLocalTime } from "@utils/dateAndTimeUtils";

/**
 * Shows high/low speeds that have been approved or are pending approval. 
 * 
 * Speed Approvals page: only lists approvals if logged in user can approve them
 * Job Control Speed Notification tab: lists all approvals for job/run. Approve/Don't Approve buttons only work if the logged in user is an approver for that run.
 * 
 * @param {Object[]} rows - live track data
 * @param {Function} onApprove 
 * @param {Function} onReject 
 * @param {Object} timezone - object from selectedJob with timezone data
 * 
 * @returns {JSX.Element}
 * 
 * @category UI
 * 
 */
export const SpeedApprovalTable = ({
  rows = [],
  onApprove,
  onReject,
  timezone
}) => {
const cellClasses = "table-cell border p-4 text-sm text-slate-700"
  if (!rows.length) return <div className="text-purple-600 font-bold italic my-6 self-center">No approvals found</div>;

  return (
    <div className='flex flex-col martrak-table-container martrak-scroll-container border my-6'>
        <table className="container table mx-auto justify-center items-center rounded-lg martrak-table border-collapse">
            <thead>
                <tr className="martrak-table-header-row">
                    <th className={`martrak-table-header ${cellClasses}`}>Run</th>
                    <th className={`martrak-table-header ${cellClasses}`}>Site</th>
                    <th className={`martrak-table-header ${cellClasses}`}>Speed (km/h)</th>
                    <th className={`martrak-table-header ${cellClasses}`}>Pass Time</th>
                    <th className={`martrak-table-header ${cellClasses}`}>Approved At</th>
                    <th className={`martrak-table-header ${cellClasses}`}>Approved By</th>

                    <th className={`martrak-table-header ${cellClasses}`}>Actions</th>
                </tr>
            </thead>

            <tbody>
                {rows.map((r) => (
                <tr key={r.ALTID} className="martrak-table-row">
                    <td>{r.Run_Name}</td>
                    <td>{r.Site_Name}</td>
                    <td>{r.Speed}</td>
                    <td>{convertToLocalTime(r.PassTime, timezone?.value)} {r.PassTime && timezone?.abbr ?timezone.abbr : null}</td>
                    <td>{convertToLocalTime(r.ApprovedAt, timezone?.value)} {r.ApprovedAt && timezone?.abbr ?timezone.abbr : null}</td>
                    <td>{r.ApprovedByName}</td>

                    {/* approve/don't approve buttons */}
                    <td className="table-cell border p-4">
                        <Button
                            onClick={() => onApprove?.(r.ALTID)}
                            disabled={!r.canApprove || r.Approved === true}
                            variant="success"
                            size="small"
                            className="mr-2 my-2"
                        >
                            Approve
                        </Button>

                        <Button
                            onClick={() => onReject?.(r.ALTID)}
                            disabled={!r.canApprove || r.Approved === true}
                            variant="danger"
                            size="small"
                        >
                            Don’t approve
                        </Button>
                    </td>
                </tr>
                ))}
            </tbody>
        </table>
    </div>
  );
};
